@if (expiresAt) {
  <div
    class="timer-container flex items-center gap-2 px-4 py-2 rounded-full transition-all duration-300"
    [class.bg-gray-100]="!isWarning && !isCritical"
    [class.bg-amber-100]="isWarning && !isCritical"
    [class.bg-red-100]="isCritical"
    [class.animate-pulse]="isCritical"
  >
    <lucide-icon
      [img]="isCritical ? icons.AlertTriangle : icons.Clock"
      class="w-4 h-4"
      [class.text-gray-600]="!isWarning && !isCritical"
      [class.text-amber-600]="isWarning && !isCritical"
      [class.text-red-600]="isCritical"
    ></lucide-icon>
    <span
      class="font-mono font-semibold text-sm"
      [class.text-gray-700]="!isWarning && !isCritical"
      [class.text-amber-700]="isWarning && !isCritical"
      [class.text-red-700]="isCritical"
    >
      {{ formattedTime }}
    </span>
  </div>
}
